import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import plane from "../../assets/images/plane.svg";
import statue from "../../assets/images/statue1.png";
import cloud from "../../assets/images/clouds.webp";

import "./SignupForm.css";

const CTASection = () => {
  const loggedIn = !!localStorage.getItem("authToken");

  useEffect(() => {
    const planeEl = document.querySelector(".cta-plane");
    const statueEl = document.querySelector(".cta-statue");

    if (!planeEl || !statueEl) return;

    const updatePlane = () => {
      const p = planeEl.getBoundingClientRect();
      const s = statueEl.getBoundingClientRect();

      const px = p.left + p.width / 2;
      const py = p.top + p.height / 2;
      const sx = s.left + s.width / 2;
      const sy = s.top + s.height / 2;

      const angle = Math.atan2(sy - py, sx - px) * (180 / Math.PI);

      const scroll = window.scrollY;

      planeEl.style.transform = `
        translate(${scroll * 0.9}px, ${-scroll * 0.15}px)
        rotate(${angle - 290}deg)
      `;
    };

    window.addEventListener("scroll", updatePlane);
    window.addEventListener("resize", updatePlane);
    updatePlane();

    return () => {
      window.removeEventListener("scroll", updatePlane);
      window.removeEventListener("resize", updatePlane);
    };
  }, []);

  return (
    <section className="cta-section" id="get-started">
      {/* Clouds */}
      <img src={cloud} className="cta-cloud cloud-left" alt="" />
      <img src={cloud} className="cta-cloud cloud-right" alt="" />

      {/* Visuals */}
      <div className="cta-visuals">
        <img src={statue} className="cta-statue" alt="Statue of Liberty" />
        <img src={plane} className="cta-plane" alt="Plane" />
      </div>

      {/* Content */}
      <div className="container text-center">
        <h2 className="cta-title">Want To Study In USA!</h2>
        <p className="cta-text">
          Join thousands of successful students who trusted{" "}
          <strong>Admissions Express</strong> to simplify their university
          applications, visa process, and scholarships.
        </p>

        <div className="cta-buttons">
          {!loggedIn ? (
            <>
              <Link to="/signup" className="cta-btn cta-primary">
                Create Free Account
              </Link>
              <Link to="/auth" className="cta-btn cta-secondary">
                Log In
              </Link>
            </>
          ) : (
            <Link to="/dashboard" className="cta-btn cta-primary">
              Go to Dashboard
            </Link>
          )}
        </div>
      </div>
    </section>
  );
};

export default CTASection;
